import { Fragment } from 'react';
import countries from '../../../assets/countries.json';
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';

import { ScreenControl } from '../ScreenControl';

import { useDispatch, useSelector } from 'react-redux'
import { setCountry } from '../../../../main/slices/userSlice';

export const CountrySelector = () => {

    const dispatch = useDispatch();
    const state = useSelector(({ user }) => user.country);

    const handleChange = (value) => dispatch(setCountry({ value, error: !value }));

    return (
        <Fragment>

            <Text classes={["subtitle"]}> ¿En qué país usarás Bitpos? </Text>
            <Text classes={["title"]}> Selecciona un país </Text>

            <List
                def={state.value}
                items={countries}
                onSelect={(c) => handleChange(c)}
                keys={{ img: "flag", text: "displayName", id: "cca2" }}
            />

            <ScreenControl disabled={state.error} ></ScreenControl>

        </Fragment>
    )
}